export const homeFaqs = [
  {
    question: "What services does our software development company provide?",
    answer:
      "We provide end-to-end software development services including custom software development, web application development, mobile app development, cloud solutions, and system integration. Our solutions help businesses automate processes, improve efficiency, and scale their digital platforms."
  },
  {
    question: "How do I choose the right software development company?",
    answer:
      "When choosing a software development company, consider their technical expertise, portfolio, industry experience, development process, and client reviews. A reliable company should understand your business goals and deliver scalable, secure, and high-performance software solutions."
  },
  {
    question: "How much does custom software development cost?",
    answer:
      "The cost of custom software development depends on the project scope, features, integrations, and development time. Small applications may take a few weeks to build, while complex enterprise systems require larger investments and longer timelines."
  },
  {
    question: "How long does it take to develop custom software?",
    answer:
      "Development timelines vary based on complexity and functionality. A simple application may take 4–8 weeks, while complex enterprise platforms may require several months for design, development, testing, and deployment."
  },
  {
    question: "Do you provide software maintenance and support?",
    answer:
      "Yes. We provide ongoing maintenance, performance monitoring, updates, and security improvements to ensure the software continues to perform efficiently after deployment."
  }
];

export const servicesFaqs = [
  {
    question: "What software development services do you offer?",
    answer:
      "We offer a wide range of services including custom software development, web application development, mobile app development, cloud-based solutions, enterprise software development, and system integration to help businesses build scalable digital platforms."
  },
  {
    question: "What technologies do you use for software development?",
    answer:
      "Our development team works with modern technologies including JavaScript frameworks, cloud platforms, APIs, databases, and scalable backend architectures to build secure and high-performance applications."
  },
  {
    question: "Can you build custom software tailored to my business needs?",
    answer:
      "Yes. We specialize in building custom software solutions designed specifically for your business workflows, operational requirements, and scalability needs."
  },
  {
    question: "Do you develop both web and mobile applications?",
    answer:
      "Yes. We develop responsive web applications as well as mobile apps for Android and iOS platforms to help businesses reach users across multiple devices."
  },
  {
    question: "Can you integrate software with existing business systems?",
    answer:
      "Yes. Our development team can integrate new software with existing systems such as CRM, ERP, payment gateways, and third-party APIs to ensure seamless operations."
  },
  {
    question: "Do you provide cloud-based software solutions?",
    answer:
      "Yes. We build cloud-enabled applications that allow businesses to access systems securely from anywhere while ensuring scalability and performance."
  },
  {
    question: "Do you provide software upgrades and modernization?",
    answer:
      "Yes. We help businesses modernize legacy software systems by upgrading technology stacks, improving performance, and enhancing user experience."
  },
  {
    question: "How do you ensure software security and quality?",
    answer:
      "We follow best practices including code reviews, automated testing, secure architecture, and performance optimization to deliver reliable and secure software solutions."
  }
];

export const caseStudiesFaqs = [
  {
    question: "What are software development case studies?",
    answer:
      "Case studies highlight real projects delivered by our team, explaining the business problem, the solution implemented, and the measurable results achieved."
  },
  {
    question: "Why should I review case studies before hiring a development company?",
    answer:
      "Case studies provide insights into the technical expertise, problem-solving ability, and project execution capabilities of a development company."
  },
  {
    question: "Can you build a similar solution for my business?",
    answer:
      "Yes. If you find a case study similar to your requirements, our team can design a customized solution tailored to your business processes."
  }
];

export const blogFaqs = [
  {
    question: "What topics are covered in your blog?",
    answer:
      "Our blog covers topics related to software development, technology trends, web development, mobile applications, digital transformation, and business automation."
  },
  {
    question: "How can businesses benefit from technology blogs?",
    answer:
      "Technology blogs provide insights into industry trends, best practices, and practical solutions that help businesses make better technology decisions."
  },
  {
    question: "How often do you publish new articles?",
    answer:
      "We regularly publish new articles to share insights about emerging technologies and software development strategies."
  }
];

export const contactFaqs = [
  {
    question: "How can I contact your team for a project discussion?",
    answer:
      "You can contact us through the website contact form or email to discuss your project requirements and schedule a consultation."
  },
  {
    question: "Do you work with international clients?",
    answer:
      "Yes. We work with businesses across different regions and collaborate remotely to deliver software development projects."
  },
  {
    question: "Do you provide consultation before starting a project?",
    answer:
      "Yes. We provide consultation sessions to understand your business requirements and recommend the most suitable technical solution."
  }
];

export const aboutFaqs = [
  {
    question: "How many years of experience do you have?",
    answer:
      "Our team at NV Seeds has several years of experience in software development, delivering web applications, business software, and digital platforms for clients across multiple industries. Our developers focus on building scalable, secure, and high-performance solutions tailored to modern business needs."
  },
  {
    question: "What industries do you specialize in?",
    answer:
      "NV Seeds develops software solutions for industries such as healthcare, retail, logistics, finance, manufacturing, and service-based businesses. Our experience across multiple sectors allows us to understand unique business challenges and build technology solutions that improve efficiency, automation, and digital transformation."
  },
  {
    question: "Where is your development team located?",
    answer:
      "Our development team operates from India and collaborates with businesses globally. We follow modern remote collaboration practices and use project management tools to ensure transparent communication, efficient development cycles, and timely project delivery."
  },
 {
    question: "Do you work with international clients?",
    answer:
      "Yes. NV Seeds works with businesses from different countries and provides remote software development services. Our team collaborates with international clients through online meetings, project management platforms, and structured development workflows to ensure smooth communication and successful project delivery."
  }
];


export const hiredevelopersFaqs = [
  {
    question: "What types of developers can I hire from your company?",
    answer:
      "You can hire front-end, back-end, full-stack, mobile app, and specialized software developers from NV Seeds. Our developers are skilled in modern technologies, frameworks, and programming languages to build scalable, secure, and high-performance applications for your business."
  },
  {
    question: "Can I hire a dedicated developer for my project?",
    answer:
      "Yes. We provide dedicated developers who work exclusively on your project. This ensures focused attention, faster delivery, and seamless integration with your existing team or project workflows."
  },
  {
    question: "How do I hire a remote developer from your team?",
    answer:
      "To hire a remote developer, simply contact us through our website or email. We’ll discuss your project requirements, recommend the best-fit developers, and onboard them with secure communication and project management tools for smooth collaboration."
  },
 {
    question: "What is the cost of hiring a developer?",
    answer:
      "The cost varies based on experience level, technology expertise, and project duration. We offer flexible engagement models including hourly, monthly, or full-time dedicated developers to match your project budget and requirements."
  },
{
    question: "How do you ensure developer accountability and quality?",
    answer:
      "We provide regular updates, code reviews, and performance tracking to ensure accountability. Our developers follow agile methodologies, version control, and testing protocols to deliver high-quality, reliable code for every project."
  },
{
    question: "What technologies and frameworks do your developers specialize in?",
    answer:
      "Our developers specialize in React, Node.js, Angular, Vue.js, Python, Java, PHP, mobile frameworks (Flutter, React Native), cloud platforms, and database technologies, enabling us to deliver custom, scalable solutions for diverse business needs."
  },
{
    question: "Can I hire a developer for a short-term project?",
    answer:
      "Yes. We provide both short-term and long-term engagements. Whether you need a developer for a single project module, MVP, or full-scale application, we can provide the right talent to match your timeline and requirements."
  },
{
    question: "Do you provide post-development support?",
    answer:
      "Yes. Our hired developers can continue supporting your project after deployment with maintenance, updates, and troubleshooting to ensure smooth operation and scalability as your business grows."
  }


];


